exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donation-form[data-v-c867d86a]{position:relative;padding:10px;max-width:400px;background:#edeceb;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.oi-donation-form input[data-v-c867d86a]{background:#fff}.oi-donation-form fieldset input[data-v-c867d86a]{margin-bottom:10px}.oi-donation-form .suggestion[data-v-c867d86a]{position:relative;top:-5px}", ""]);

// exports
